<medical-order-scann-control [medicalorderId]="medicalorderId"></medical-order-scann-control>